import _ from 'lodash';
import * as dataService from 'views/Classifier/shared/_services';
import * as groupService from 'views/ClassifierGroups/shared/_services';


const parentOptions = async () => {
  const records = await dataService.getAll();

  return _.map(records, record => ({ 
    value: record._id, 
    label: `${record.code} - ${record.title}`,
  }));
};

const groupOptions = async () => {
  const records = await groupService.getAll();

  return _.map(records, record => ({ 
    value: record._id, 
    label: `${record.code} - ${record.title}`,
  }));
};


export default [
  {
    name: 'code',
    label: 'Kodas',
    type: 'text',
  },
  {
    name: 'title',
    label: 'Pavadinimas',
    type: 'text',
  },
  {
    name: 'parent',
    label: 'Priklauso kodui',
    type: 'select',
    options: parentOptions,
  },
  {
    name: 'group',
    label: 'Klasifikatoriaus grupė',
    type: 'select',
    options: groupOptions,
  },
]